import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { News } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: { list: News[]; lockItem: number } = {
  list: [],
  lockItem: -1,
}

export const getAll = createAsyncThunk('News/getAll', async () => {
  const { data } = await axiosClient.get('/api/news')
  return data
})
export const getOne = createAsyncThunk(
  'News/getOne',
  async (id: string | number) => {
    const { data } = await axiosClient.get('/api/news/' + id)
    return data
  }
)

export const NewsSlice = createSlice({
  name: 'News',
  initialState,
  reducers: {
    removeItem(state, { payload }: PayloadAction<number>) {
      const index = state.list.findIndex((f) => f.id === payload)
      if (index >= 0) {
        state.list[index].active = false
      }
    },
    lockItem(state, { payload }: PayloadAction<number>) {
      state.lockItem = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, { payload }) => {
      state.list = payload
    })
    builder.addCase(getOne.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex((f) => f.id === payload.id)
      if (index >= 0) {
        state.list.splice(index, 1, payload)
      } else {
        state.list.unshift(payload)
      }
    })
  },
})

export const NewsAction = NewsSlice.actions

export const NewsReducer = NewsSlice.reducer
